(function () {
  var STICKY_SELECTOR = '.product-form__sticky-buy-button';
  var PRODUCT_FORM_SELECTOR = 'product-form';
  var VARIANT_PICKER_SELECTOR = 'variant-picker.product-variant-picker';
  var OPTIONS_SCROLL_SELECTOR = '[data-mystic-sticky-options-scroll]';
  var OPTIONS_SUMMARY_SELECTOR = '[data-mystic-sticky-options-summary]';
  var STICKY_IMAGE_SELECTOR = '[data-mystic-sticky-image]';
  var VARIANT_IMAGE_MAP_SELECTOR = '[data-mystic-sticky-variant-images]';
  var SOURCE_SUBMIT_SELECTOR = 'button[type="submit"][name="add"]:not([form])';
  var TRIGGER_SELECTORS = [
    '.product-form__purchase-row',
    '.product-form__btns > .product-button-block',
    '.product__info .product-button-block'
  ];
  var stickyIndex = 0;

  function isUsableElement(element) {
    if (!element) return false;
    if (element.closest(STICKY_SELECTOR)) return false;

    var styles = window.getComputedStyle(element);
    if (styles.display === 'none' || styles.visibility === 'hidden' || Number(styles.opacity) === 0) {
      return false;
    }

    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function isElementInView(element) {
    if (!isUsableElement(element)) return false;

    var rect = element.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function hasScrolledPastElement(element) {
    if (!isUsableElement(element)) return false;

    return element.getBoundingClientRect().bottom <= 0;
  }

  function findProductScope(stickyButton) {
    var form = stickyButton._mysticProductForm || stickyButton.closest(PRODUCT_FORM_SELECTOR);

    return (form && (form.closest('.product__info') || form.closest('.product'))) || document;
  }

  function getVariantValues(sourcePicker) {
    if (!sourcePicker) return [];

    return Array.prototype.slice
      .call(sourcePicker.querySelectorAll('.product-variant-picker__option-label'))
      .map(function (label) {
        var name = label.querySelector('.heading-font-family');
        var value = label.querySelector('.product-variant-picker__option-active-color, [data-dropdown-variant-picker-label] span');

        if (!name || !value) return '';

        return [name.textContent, value.textContent]
          .map(function (text) {
            return text.trim();
          })
          .filter(Boolean)
          .join(': ');
      })
      .filter(Boolean);
  }

  function updateOptionsSummary(stickyButton) {
    var summary = stickyButton.querySelector(OPTIONS_SUMMARY_SELECTOR);
    if (!summary) return;

    var sourcePicker = findProductScope(stickyButton).querySelector(VARIANT_PICKER_SELECTOR);
    var values = getVariantValues(sourcePicker);

    if (values.length > 0) {
      var nextSummary = values.join(' | ');

      if (summary.textContent !== nextSummary) {
        summary.textContent = nextSummary;
      }
    }
  }

  function getSelectedVariantId(stickyButton) {
    var field = findProductScope(stickyButton).querySelector('input[name="id"], select[name="id"]');

    return field ? field.value : '';
  }

  function updateStickyImage(stickyButton) {
    var image = stickyButton.querySelector(STICKY_IMAGE_SELECTOR);
    var mapElement = stickyButton.querySelector(VARIANT_IMAGE_MAP_SELECTOR);
    var variantId = getSelectedVariantId(stickyButton);

    if (!image || !mapElement || !variantId) return;

    try {
      var imageMap = JSON.parse(mapElement.textContent || '{}');
      var imageData = imageMap[variantId];

      if (!imageData || !imageData.src) return;

      if (image.getAttribute('src') !== imageData.src) {
        image.src = imageData.src;
      }

      if (image.hasAttribute('srcset')) {
        image.removeAttribute('srcset');
      }

      if (imageData.alt && image.alt !== imageData.alt) {
        image.alt = imageData.alt;
      }
    } catch (error) {
      return;
    }
  }

  function getSourceSubmit(stickyButton) {
    var sourceForm = stickyButton._mysticSourceForm;

    return sourceForm ? sourceForm.querySelector(SOURCE_SUBMIT_SELECTOR) : null;
  }

  function mirrorSubmitState(sourceSubmit, stickySubmit) {
    if (!sourceSubmit || !stickySubmit) return;

    stickySubmit.classList.toggle('loading', sourceSubmit.classList.contains('loading'));
    stickySubmit.toggleAttribute('disabled', sourceSubmit.disabled || sourceSubmit.hasAttribute('disabled'));

    var sourceLabel = sourceSubmit.getAttribute('aria-label');
    if (sourceLabel) {
      stickySubmit.setAttribute('aria-label', sourceLabel);
    }

    var sourceText = sourceSubmit.querySelector('[data-button-text]');
    var stickyText = stickySubmit.querySelector('[data-button-text]');
    if (sourceText && stickyText && stickyText.innerHTML !== sourceText.innerHTML) {
      stickyText.innerHTML = sourceText.innerHTML;
    }
  }

  function findTrigger(stickyButton) {
    var form = stickyButton._mysticProductForm || stickyButton.closest(PRODUCT_FORM_SELECTOR);
    var scope = form || document;

    for (var i = 0; i < TRIGGER_SELECTORS.length; i += 1) {
      var matches = scope.querySelectorAll(TRIGGER_SELECTORS[i]);

      for (var j = 0; j < matches.length; j += 1) {
        if (isUsableElement(matches[j])) {
          return matches[j];
        }
      }
    }

    return form;
  }

  function mountStickyButton(stickyButton) {
    if (stickyButton.dataset.mysticStickyMounted === 'true') return;

    var productForm = stickyButton.closest(PRODUCT_FORM_SELECTOR);
    var formElement = stickyButton.closest('form');
    var submitButton = stickyButton.querySelector('button[type="submit"]');

    stickyButton._mysticProductForm = productForm;
    stickyButton._mysticSourceForm = formElement;
    stickyButton.dataset.mysticStickyMounted = 'true';

    if (formElement && submitButton) {
      var formId = formElement.getAttribute('id');

      if (!formId) {
        stickyIndex += 1;
        formId = 'mystic-product-form-' + stickyIndex;
        formElement.setAttribute('id', formId);
      }

      submitButton.setAttribute('form', formId);
      var sourceSubmit = getSourceSubmit(stickyButton);

      mirrorSubmitState(sourceSubmit, submitButton);

      if (sourceSubmit && !stickyButton._mysticSubmitObserver) {
        stickyButton._mysticSubmitObserver = new MutationObserver(function () {
          mirrorSubmitState(sourceSubmit, submitButton);
        });
        stickyButton._mysticSubmitObserver.observe(sourceSubmit, {
          attributes: true,
          attributeFilter: ['class', 'disabled', 'aria-label'],
          childList: true,
          characterData: true,
          subtree: true
        });
      }

      submitButton.addEventListener('click', function (event) {
        var sourceSubmit = getSourceSubmit(stickyButton);

        if (!sourceSubmit || sourceSubmit.disabled) return;

        event.preventDefault();
        mirrorSubmitState(sourceSubmit, submitButton);
        sourceSubmit.click();
      });
    }

    updateOptionsSummary(stickyButton);
    updateStickyImage(stickyButton);
    document.body.appendChild(stickyButton);
  }

  function removeDisconnectedStickyButtons() {
    document.querySelectorAll(STICKY_SELECTOR).forEach(function (stickyButton) {
      if (
        stickyButton._mysticProductForm &&
        !document.documentElement.contains(stickyButton._mysticProductForm)
      ) {
        stickyButton.remove();
      }
    });
  }

  function syncStickyButton(stickyButton) {
    var trigger = findTrigger(stickyButton);
    var footer = document.querySelector('.shopify-section.shopify-section-footer');
    var footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
    var shouldHideForFooter = footerTop <= stickyButton.offsetHeight;
    var shouldShow = trigger && !isElementInView(trigger) && hasScrolledPastElement(trigger) && !shouldHideForFooter;

    updateOptionsSummary(stickyButton);
    updateStickyImage(stickyButton);
    stickyButton.classList.toggle('is-visible', shouldShow);

    document.body.toggleAttribute(
      'is-product-form-button-fixed',
      Boolean(document.querySelector(STICKY_SELECTOR + '.is-visible'))
    );
  }

  function syncAllStickyButtons() {
    removeDisconnectedStickyButtons();

    document.querySelectorAll(STICKY_SELECTOR).forEach(function (stickyButton) {
      mountStickyButton(stickyButton);
      syncStickyButton(stickyButton);
    });
  }

  var queued = false;
  function queueSync() {
    if (queued) return;

    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      syncAllStickyButtons();
    });
  }

  document.addEventListener('DOMContentLoaded', syncAllStickyButtons);
  window.addEventListener('load', syncAllStickyButtons);
  window.addEventListener('scroll', queueSync, { passive: true });
  window.addEventListener('resize', queueSync);
  document.addEventListener('variant-change', function () {
    window.setTimeout(queueSync, 0);
  });
  document.addEventListener('change', function (event) {
    if (event.target.closest(STICKY_SELECTOR)) {
      window.setTimeout(queueSync, 0);
      return;
    }

    queueSync();
  });
  document.addEventListener('click', function (event) {
    var scrollButton = event.target.closest(OPTIONS_SCROLL_SELECTOR);
    if (!scrollButton) return;

    var stickyButton = scrollButton.closest(STICKY_SELECTOR);
    if (!stickyButton) return;

    var sourcePicker = findProductScope(stickyButton).querySelector(VARIANT_PICKER_SELECTOR);
    var target = sourcePicker || findTrigger(stickyButton);

    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', syncAllStickyButtons);
  }
})();
